<div class="flex justify-center max-w-[70rem]">
  <p-card>
    <div class="flex flex-col items-center gap-4 justify-between h-[60vh] w-[80vw]
           sm:h-[70vh] sm:w-[25vw] md:h-[350px] p-1 lg:p-4">
      <img alt="Sisdemanda" height="98" ngSrc="logo.png" width="300"/>

      <div class="text-center">
        <p class="text-lg text-red-500">Sessão Expirou</p>
        <p class="text-sm text-red-500">Faça novamente seu login</p>
      </div>

      <p-button (click)="onAcessar()"
          (keydown.enter)="$event.preventDefault(); onAcessar()"
          (keydown.space)="$event.preventDefault(); onAcessar()" class="w-full" label="Acessar" styleClass="btn-gray">
        <app-icon-login/>
      </p-button>
    </div>
  </p-card>
</div>
